import './App.css';
import MainComponent from './Components/MainComponent';
function App() {


  return (
    <div>
      <MainComponent/>
      <div style={{ height: '8vh' }}>
      </div>
    </div>
  )
}

export default App;

